(function () {
  var root = document.querySelector('[data-astra-auth]');
  if (!root) return;

  var showLabel = root.getAttribute('data-astra-show-password') || '';
  var hideLabel = root.getAttribute('data-astra-hide-password') || '';

  root.querySelectorAll('[data-astra-toggle-password]').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = document.getElementById(button.getAttribute('data-astra-toggle-password'));
      if (!input) return;
      var hidden = input.getAttribute('type') === 'password';
      input.setAttribute('type', hidden ? 'text' : 'password');
      button.setAttribute('aria-label', hidden ? hideLabel : showLabel);
    });
  });

  var form = root.querySelector('.astra-auth-form');
  var confirm = root.querySelector('[data-astra-password-confirm]');
  var password = root.querySelector('#AstraPassword');
  var feedback = root.querySelector('[data-astra-auth-feedback]');
  if (form && confirm && password) {
    form.addEventListener('submit', function (event) {
      var mismatch = password.value !== confirm.value;
      var privacy = root.querySelector('[data-astra-privacy]');
      var privacyOff = privacy && !privacy.checked;
      if (!mismatch && !privacyOff) {
        if (feedback) feedback.hidden = true;
        return;
      }
      event.preventDefault();
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = mismatch
        ? root.getAttribute('data-astra-mismatch') || ''
        : root.getAttribute('data-astra-privacy') || '';
      (mismatch ? confirm : privacy).focus();
    });
  }

  var loginPanel = root.querySelector('[data-astra-login-panel]');
  var recover = root.querySelector('[data-astra-recover]');
  function showRecover(open) {
    if (!recover || !loginPanel) return;
    recover.hidden = !open;
    loginPanel.hidden = open;
  }
  root.querySelectorAll('[data-astra-open-recover]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      showRecover(true);
      var email = document.getElementById('AstraRecoverEmail');
      if (email) email.focus();
    });
  });
  root.querySelectorAll('[data-astra-close-recover]').forEach(function (button) {
    button.addEventListener('click', function () {
      showRecover(false);
    });
  });
  if (window.location.hash === '#recover' || (recover && !recover.hidden)) {
    showRecover(true);
  }
})();
